import { Map } from 'immutable'
import * as forms from '../components/forms/form'

export const CONNECTED_INPUT_UPDATE = 'forms/connected-input-update'

const initialState = Map({
  [forms.inflationEstimateKey]: 0,
  [forms.preAssetsReturnKey]: 0,
  [forms.postAssetsReturnKey]: 0,
  [forms.ssIncomeKey]: 0,
  [forms.pensionIncomeKey]: 0,
  [forms.yearsUntilRetirementKey]: 0,
  [forms.yearsInRetirementKey]: 0,
  [forms.taxDeferredSavingsKey]: 0,
  [forms.taxFreeSavingsKey]: 0,
  [forms.taxRateKey]: 0
})

/**
 *
 * @param state
 * @param action
 * @returns {*|Map<K, V>|Map<string, V>}
 */
export default function reducer (state = initialState, action) {
  switch (action.type) {
    case CONNECTED_INPUT_UPDATE: {
      return state.set(action.key, action.val)
    }
    default: {
      return state
    }
  }
}

export function connectedInputUpdate (key, val) {
  return {
    type: CONNECTED_INPUT_UPDATE,
    key,
    val
  }
}



// WEBPACK FOOTER //
// ./src/redux/forms-reducer.js